<template>
    <v-row v-if="loading.books" dense>
        <v-col class="text-center">
            <v-card
                outlined>
                <v-card-text>
                    <loading-linear message="Loading Relevant Titles ...">
                    </loading-linear>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <div v-else>
        <divider-expand
            v-if="!isMobilePort && books.length"
            :open-by-default="showRelevantTitles"
            :activateSearchTab="this.$getConst('titleSearchType')"
            buttonText="See More Titles">
            <p class="fs-14 mb-0 d-inline font-weight-medium">
                Relevant Titles
            </p>
            <template v-slot:expand>
                <title-list
                    :titles="books"
                    :loading="loading.books"
                    :itemsPerPage="itemsPerPage"
                    displayCompacted>
                </title-list>
            </template>
        </divider-expand>
    </div>
</template>

<script>
    import Mobile from '../../inc/mixins/mobile';
    import {SuperAxios} from "../../../api/SuperAxios";

    import TitleCover from "../../titles/cover/Index.vue";
    import TitleList from '../../content/title/TitleList.vue';
    import DividerExpand from "../../expands/DividerExpand.vue";
    import LoadingLinear from '../../loaders/LoadingLinear.vue';

    export default {
        data() {
            return {
                books: [],
                loading: {
                    books: true
                },
                itemsPerPage: 2,
                limit: 2,
                showRelevantTitles: true
            }
        },
        mixins: [Mobile],
        components: {
            DividerExpand,
            TitleCover,
            TitleList,
            LoadingLinear
        },
        methods: {
            getTitleResults(search) {
                const query = search ? search : this.defaultSearch;
                this.loading.books = true;
                const apiUrl = Routing.generate('search_titles', {
                    query: query,
                    limit: this.limit
                });

                SuperAxios.getOnce(apiUrl).then(response => {
                    this.books = response.data.data;
                    this.$set(this.loading, 'books', false);
                }).catch(this.handleError);
            },
            toggle() {
                this.showRelevantTitles = !this.showRelevantTitles;
            },
            resetData(){
                this.books = [];
                this.loading.books = true;
                this.itemsPerPage = 6;
            }
        },
        mounted() {
            this.getTitleResults();
            EventBus.listen('get-relevant-titles-results', (search = '') => {
                this.resetData();
                this.getTitleResults(search);
            });
        }
    }
</script>
